import React from 'react';
import {ModalBody, ModalFooter} from 'reactstrap';
import {APIClient} from "../../../utils/APIClient";
import {API_URL} from "../../../settings/local_settings";
import {Spinner} from "../../Spinner";
import {CHANNEL_ACCOUNT_SELECT_SPECIAL_ITEMS, ChannelAccountSelect} from "../../selects/ChannelAccountSelect";
import {ClientSelect} from "../../selects/ClientSelect";
import {ANALYTICS_CHANNEL, CHANNEL_INFO_BY_CHANNEL, CHANNEL_TYPE_ANALYTICS, CHANNEL_TYPE_PAID_MEDIA, GOOGLE_CHANNEL, SHEET_CHANNEL} from "../../channels/channels";
import {ChannelLogo} from "../../channels/ChannelLogo";
import {AddAdAccountModal} from "../../channels/sheet/AddAdAccountModal";
import {ClientAdAccountFormBaseClass} from "./ClientAdAccountFormBase";
import { withTranslation } from 'react-i18next';

export class AddClientAdAccountFormClass extends ClientAdAccountFormBaseClass {

    constructor(props) {
        super(props);

        const adAccountIsAlreadySelected = (this.props.channel !== undefined && this.props.adAccountId !== undefined);
        const selectedAccount = this.props.adAccountId !== undefined ? this.props.adAccountId : null;
        const channel = this.props.channel !== undefined ? this.props.channel : GOOGLE_CHANNEL;

        this.state = {
            ...this.state,
            creatingClientAdAccount: false,
            allGoogleAccounts: null,
            allFacebookAccounts: null,
            allTiktokAccounts: null,
            allLinkedinAccounts: null,
            allSheetAccounts: null,
            allAnalyticsAccounts: null,
            agencyChannels: null,
            agencyAnalyticsChannels: null,
            channel: channel,
            adAccountIsAlreadySelected: adAccountIsAlreadySelected,
            selectedAccount: selectedAccount,
            selectedClient: null,
            agencyClients: null,
            hasClickedOnSubmit: false,
            dailyLimitEnabled: false
        };

        this.handleSelectedChannelChange = this.handleSelectedChannelChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleAccountChange = this.handleAccountChange.bind(this);
        this.handleClientChange = this.handleClientChange.bind(this);
        this.handleDailyLimitEnabledChange = this.handleDailyLimitEnabledChange.bind(this);
        this.afterSuccessfulSheetAdAccountSubmit = this.afterSuccessfulSheetAdAccountSubmit.bind(this);
        this.footerButton = this.footerButton.bind(this);
    }

    componentDidMount() {

        this.getActiveAgencyClients();

        if(!this.state.adAccountIsAlreadySelected) {
            this.getAllFacebookAccounts();
            this.getAllTiktokAccounts();
            this.getAllLinkedinAccounts();
            this.getAllGoogleAccounts();
            this.getAllSheetAccounts();
            this.getAllAnalyticsAccounts();
            this.getAgencyChannels();
            this.getAgencyAnalyticsChannels();
        }
    }

    // API

    getAllFacebookAccounts() {
        this.getAccountsForChannel('FACEBOOK', (accounts) => {
            this.setState({
                allFacebookAccounts: accounts
            })
        });
    }

    getAllTiktokAccounts() {
        this.getAccountsForChannel('TIKTOK', (accounts) => {
            this.setState({
                allTiktokAccounts: accounts
            })
        });
    }

    getAllLinkedinAccounts() {
        this.getAccountsForChannel('LINKEDIN', (accounts) => {
            this.setState({
                allLinkedinAccounts: accounts
            })
        });
    }

    getAllGoogleAccounts() {
        this.getAccountsForChannel('GOOGLE', (accounts) => {
            this.setState({
                allGoogleAccounts: accounts
            })
        });
    }

    getAgencyChannels(){
        new APIClient(this.getAgencyChannelsURL()).call('GET').then((response) => {
            if (response.status === 'ERROR') {
                alert(response.error_message);
                this.setState({
                    agencyChannels: []
                })
            } else if (response.status === 'OK') {
                this.setState({
                    agencyChannels: response.data
                })
            }
        });
    }

    getAgencyAnalyticsChannels(){
        new APIClient(this.getAgencyAnalyticsChannelsURL()).call('GET').then((response) => {
            if (response.status === 'ERROR') {
                this.setState({
                    agencyAnalyticsChannels: []
                })
            } else if (response.status === 'OK') {
                this.setState({
                    agencyAnalyticsChannels: response.data
                })
            }
        });
    }

    getAllSheetAccounts() {
        this.getAccountsForChannel('SHEET', (accounts) => {
            this.setState({
                allSheetAccounts: accounts
            })
        });
    }

    getAllAnalyticsAccounts() {
        this.getAccountsForChannel('ANALYTICS', (accounts) => {
            this.setState({
                allAnalyticsAccounts: accounts
            })
        });
    }

    getActiveAgencyClients() {
        new APIClient(this.getActiveAgencyClientsURL()).call('GET').then((response) => {
            if (response.status === 'ERROR') {
                alert(response.error_message);
                this.setState({
                    agencyClients: []
                })
            } else if (response.status === 'OK') {
                this.setState({
                    agencyClients: response.data
                })
            }
        });
    }

    getAccountsForChannel(channel, callback) {
        new APIClient(this.getAccountsForChannelURL(channel)).call('GET').then((response) => {
            if (response.status === 'ERROR') {
                alert(response.error_message);
                callback([]);
            } else if (response.status === 'OK') {
                callback(response.data)
            }
        });
    }

    getClientId() {
        return this.props.clientId ? this.props.clientId : this.state.selectedClient
    }


    handleSubmit(event) {
        event.preventDefault();

        // El error lo muestra el componente. Se entera porque se le pasa el hasClickedOnSubmit
        if(this.state.selectedAccount === null || CHANNEL_ACCOUNT_SELECT_SPECIAL_ITEMS.includes(this.state.selectedAccount))
        {
            this.setState({hasClickedOnSubmit: true});
            return;
        }

        this.setState({
            creatingClientAdAccount: true,
        });

        new APIClient(this.submitUrl()).call('POST', this.getDataToPost(event)).then((data) => {
            this.setState({
                creatingClientAdAccount: false
            });

            if (data.status !== 'OK') {
                alert(data.error_message);
            } else if (data.status === 'OK') {
                this.props.afterSuccessfulSubmit(
                    data.data.agency_client_ad_account_id,
                    this.state.channel,
                    data.data.ad_account_id
                )
            }
        });
    }

    getDataToPost(event) {

        const channel = this.state.adAccountIsAlreadySelected === true ? this.state.channel : event.target.campaignChannel.value;
        const ad_account_id = this.state.selectedAccount;

        return {
            'client_id': this.getClientId(),
            'account_id': ad_account_id.toString(),
            'channel': channel,
            ...this._getDataToPost()
        };
    }

    handleDailyLimitEnabledChange(event) {
        this.setState({
            dailyLimitEnabled: event.target.checked
        });
    }

    handleSelectedChannelChange(event) {
        event.preventDefault();
        this.setState({
            channel: event.target.value,
            selectedAccount: null
        });
    }

    handleAccountChange(accountId, accountName) {
        // Si selecciono "NUEVA CUENTA". Segun el canal seleccionado se muestra el modal de creacion de cuenta correspondiente
        if (this.state.channel === SHEET_CHANNEL && accountId === "CREATE_NEW_ACCOUNT") {
            this.addSheetAdAccountModal.toggle();
        }

        this.setState({
            selectedAccount: accountId
        })
    }

    handleClientChange(clientId, clientName) {
        this.setState({
            selectedClient: clientId
        })
    }

    footerButton() {
        const { t } = this.props;
        if (this.state.creatingClientAdAccount) {
            return <Spinner color="positive small"/>
        } else {
            return <input type="submit" value={t('add_client_ad_account_form.add')} className="btn -submit"/>
        }
    }

    addingAdAccountForAPredefinedClient() {
        return typeof this.props.clientId !== 'undefined' && this.props.clientId > 0;
    }

    renderClientInput() {
        if (this.addingAdAccountForAPredefinedClient()) {
            return (<input name="client" type="text" value={this.props.clientName} readOnly={true}
                           className="form-control pl-3"/>)
        } else {
            return (<ClientSelect selectedOption={this.state.selectedClient}
                                  allClients={this.state.agencyClients}
                                  onClientChange={this.handleClientChange}
                                  required={true}
            />)
        }
    }

    getAllAvailableChannels() {
        const paidMediaChannels = this.state.agencyChannels || [];
        const analyticsChannels = this.state.agencyAnalyticsChannels || [];
        return [...paidMediaChannels, ...analyticsChannels];
    }

    handleChannelCardClick(channel) {
        this.setState({
            channel: channel,
            selectedAccount: null
        });
    }

    renderChannelsSelect() {
        const { t } = this.props;
        if(this.state.agencyChannels === null || this.state.agencyAnalyticsChannels === null)
            return <p>{t('common.loading')}</p>

        const allChannels = this.getAllAvailableChannels();

        return <div className="channel-selection-cards">
            {allChannels.map((channel) =>
                <div key={channel}
                     className={`channel-card${this.state.channel === channel ? ' -selected' : ''}`}
                     onClick={() => this.handleChannelCardClick(channel)}>
                    <span className="channel-card-icon">
                        <ChannelLogo channel={channel} width={18} height={18} hspace={0} vspace={0} marginLeft={0} padding={0} useOld={false}/>
                    </span>
                    <span className="channel-card-name">{CHANNEL_INFO_BY_CHANNEL[channel]["Spanish"]}</span>
                </div>
            )}
            <input type="hidden" name="campaignChannel" value={this.state.channel}/>
        </div>
    }

    renderSheetNewAddAccountModal() {
        return <AddAdAccountModal ref={instance => {
            this.addSheetAdAccountModal = instance;
        }}
                                  afterSuccessfulSubmit={this.afterSuccessfulSheetAdAccountSubmit}/>
    }

    afterSuccessfulSheetAdAccountSubmit(newSheetAdAccountData) {
        const allSheetAdAccounts = this.state.allSheetAccounts;
        const data = {
            'id': newSheetAdAccountData.account_id,
            'name': newSheetAdAccountData.name,
            'name_with_parents': newSheetAdAccountData.name,
            'currency_code': newSheetAdAccountData.currency,
            'parents_account_ids': []
        };

        allSheetAdAccounts.push(data);
        this.setState({
            allSheetAccounts: allSheetAdAccounts,
            selectedAccount: newSheetAdAccountData.account_id
        });
    }

    render() {
        const { t } = this.props;
        return [
            <form onSubmit={this.handleSubmit}>
                <ModalBody>
                    <div className="modal-section">
                        <div className="row g-3 mb-3">
                            <div className="col-6">
                                <label className="form-label">{t('add_client_ad_account_form.client')}</label>
                                {this.renderClientInput()}
                            </div>
                            <div className="col-6">
                                &nbsp;
                            </div>
                        </div>
                        {this.renderSelectAccountSection()}
                        {this.renderDailyLimitSection()}
                    </div>
                </ModalBody>
                <ModalFooter>
                    {this.footerButton()}
                </ModalFooter>
            </form>,
            this.renderSheetNewAddAccountModal()
        ];
    }

    renderSelectAccountSection() {
        const { t } = this.props;
        if(this.state.adAccountIsAlreadySelected)
            return;

        return <div className="mb-3" id="account_selector_group">
            <label className="separator">{t('add_client_ad_account_form.account')}</label>
            <div className="mb-3">
                <label className="form-label">{t('link_account_modal.channel_label')}</label>
                {this.renderChannelsSelect()}
            </div>
            <div>
                <label className="form-label">{t('add_client_ad_account_form.account')}</label>
                <ChannelAccountSelect channel={this.state.channel}
                                      selectedAccount={this.state.selectedAccount}
                                      allAccounts={this.allAccountsOfChannel(this.state.channel)}
                                      onAccountChange={this.handleAccountChange}
                                      canCreateNewAccount={CHANNEL_INFO_BY_CHANNEL[this.state.channel].CreateAccount}
                                      showFormValidationTexts={this.state.hasClickedOnSubmit}
                />
            </div>
        </div>;
    }

    renderDailyLimitSection() {
        if(!CHANNEL_INFO_BY_CHANNEL[this.state.channel].dailyLimitEnabled)
            return;

        return this.renderRadioButtonOptions();
    }

// aux

    allAccountsOfChannel(channel) {
        if (channel === 'GOOGLE') {
            return this.state.allGoogleAccounts
        } else if (channel === 'FACEBOOK') {
            return this.state.allFacebookAccounts
        } else if (channel === 'TIKTOK') {
            return this.state.allTiktokAccounts
        } else if (channel === 'LINKEDIN') {
            return this.state.allLinkedinAccounts
        } else if (channel === 'SHEET') {
            return this.state.allSheetAccounts
        } else if (channel === 'ANALYTICS') {
            return this.state.allAnalyticsAccounts
        }
    }

    // URLS

    getAgencyChannelsURL(channel) {
        return `${API_URL}get-channels/${CHANNEL_TYPE_PAID_MEDIA}/`
    }

    getAgencyAnalyticsChannelsURL() {
        return `${API_URL}get-channels/${CHANNEL_TYPE_ANALYTICS}/`
    }

    getAccountsForChannelURL(channel) {
        return `${API_URL}get-accounts/${channel}`
    }

    getActiveAgencyClientsURL() {
        return `${API_URL}agency/clients/active`
    }

    submitUrl() {
        return API_URL + 'client/' + this.getClientId() + '/ad_account/add';
    }
}

export const AddClientAdAccountForm = withTranslation()(AddClientAdAccountFormClass);
export default AddClientAdAccountForm;
